import React, { useState } from 'react';
import { isAndroid, isChrome, isIOS, isSafari } from 'react-device-detect';
import { NavLink } from 'react-router-dom';

import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Modal from 'Component/Modal';
import { useIsInstalled } from 'Hook/App';
import { ocultarAjudaParaInstalacao } from 'Reducer/Config';
import { useAppDispatch, useAppSelector } from 'Store';

const MenuInferior = (): React.ReactElement => {
  const isInstalled = useIsInstalled();
  const dispatch = useAppDispatch();
  const { exibirMenu, ajudaParaInstalacao } = useAppSelector(
    (estado) => estado.config
  );
  const [modal, setModal] = useState<boolean>(false);

  return (
    <div
      className={`fixed-bottom z-index-500 animate__animated ${
        exibirMenu ? 'animate__slideInUp' : 'animate__slideOutDown'
      }`}
    >
      {!isInstalled && (
        <>
          {ajudaParaInstalacao && (
            <div className="w-100 cursor-pointer">
              <div className="bg-primary py-3 px-4 text-white text-center d-flex justify-content-between align-items-center">
                <span onClick={() => setModal(true)}>
                  Clique aqui e instale o App agora!
                </span>
                <Botao
                  sm
                  tema="transparent"
                  onClick={() => dispatch(ocultarAjudaParaInstalacao())}
                >
                  <Icone nome="x-lg" className="text-white" />
                </Botao>
              </div>
            </div>
          )}
          <Modal
            exibir={modal}
            aoFechar={setModal}
            titulo="Instale o App do Estude+"
          >
            <>
              {isAndroid && !isChrome && (
                <p>
                  Para poder instalar o App em seu Android, você precisa
                  primeiramente abrir o Estude+ usando o navegador{' '}
                  <strong>Chrome</strong>.
                </p>
              )}
              {isAndroid && isChrome && (
                <>
                  <p>
                    Para instalar o App em seu <strong>Android</strong>, clique
                    no ícone <Icone nome="three-dots-vertical" /> do navegador
                    Chrome.
                  </p>
                  <p>
                    Logo em seguida, clique{' '}
                    <strong>&quot;Adicionar à tela inicial&ldquo;</strong>.
                  </p>
                </>
              )}
              {isIOS && !isSafari && (
                <p>
                  Para poder instalar o App em seu iPhone, você precisa
                  primeiramente abrir o Estude+ usando o navegador{' '}
                  <strong>Safari</strong>.
                </p>
              )}
              {isIOS && isSafari && (
                <>
                  <p>
                    Para instalar o App em seu <strong>iPhone</strong>, clique
                    no ícone <Icone nome="box-arrow-up" /> do navegador Safari.
                  </p>
                  <p>
                    Logo em seguida, clique{' '}
                    <strong>&quot;Adicionar à Tela de Início&ldquo;</strong>.
                  </p>
                </>
              )}
            </>
          </Modal>
        </>
      )}
      <nav
        id="navbar-footer"
        className="navbar navbar-expand navbar-dark p-0 mb-0"
        style={{
          backdropFilter: 'blur(20px) saturate(300%)',
          WebkitBackdropFilter: 'blur(20px) saturate(300%)',
          backgroundColor: 'rgba(49, 49, 46, 0.73)',
        }}
      >
        <ul className="navbar-nav w-100 d-flex justify-content-between">
          <li className="nav-item" style={{ flex: 1 }}>
            <NavLink
              to="/estudar/home"
              className={({ isActive }) =>
                `nav-link text-center ${
                  isActive ? 'text-secondary' : 'text-white'
                }`
              }
            >
              <Icone nome="house" className="mb-1 fs-5" />
              <small className="d-block">Início</small>
            </NavLink>
          </li>
          <li className="nav-item" style={{ flex: 1 }}>
            <NavLink
              to="/estudar/meus-estudos"
              className={({ isActive }) =>
                `nav-link text-center ${
                  isActive ? 'text-secondary' : 'text-white'
                }`
              }
            >
              <Icone nome="book" className="mb-1 fs-5" />
              <small className="d-block">Estudos</small>
            </NavLink>
          </li>
          <li className="nav-item" style={{ flex: 1 }}>
            <NavLink
              to="/estudar/categorias"
              className={({ isActive }) =>
                `nav-link text-center ${
                  isActive ? 'text-secondary' : 'text-white'
                }`
              }
            >
              <Icone nome="view-list" className="mb-1 fs-5" />
              <small className="d-block">Categorias</small>
            </NavLink>
          </li>
          <li className="nav-item" style={{ flex: 1 }}>
            <NavLink
              to="/estudar/buscar"
              className={({ isActive }) =>
                `nav-link text-center ${
                  isActive ? 'text-secondary' : 'text-white'
                }`
              }
            >
              <Icone nome="search" className="mb-1 fs-5" />
              <small className="d-block">Buscar</small>
            </NavLink>
          </li>
          <li className="nav-item" style={{ flex: 1 }}>
            <NavLink
              to="/estudar/solicitacoes"
              className={({ isActive }) =>
                `nav-link text-center ${
                  isActive ? 'text-secondary' : 'text-white'
                }`
              }
            >
              <Icone nome="question-lg" className="mb-1 fs-5" />
              <small className="d-block">Ajuda</small>
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MenuInferior;
